export const wrapperClass = `inline-flex items-center`;
export const inputClass = `
  text-blue-700 dark:text-blue-500
  focus:ring-blue-700 dark:focus:ring-blue-500
  rounded-md transition hover:shadow-lg focus:shadow-lg
`;
export const labelClass = `flex-1 -ml-7 pl-10 py-0.5`;
